module.exports = __webpack_public_path__ + "static/media/shoe_06.855d9303.jpg";